import { FlowComponent } from '../../flow.min.js';
import styles from './styles.js'; // Reusamos los estilos del login

// Importamos los átomos para asegurar que estén registrados
import '../ui/flow-input/flow-input.js';
import '../ui/flow-checkbox/flow-checkbox.js';
import '../ui/flow-button/flow-button.js';

const template = FlowComponent.html`
    <form action="/api/v1/auth/login" method="POST" class="flex flex-col space-y-4">
        
        <flow-input
            class="order-1"
            label="Correo electrónico"
            type="email"
            name="email"
            placeholder="admin@ejemplo.com"
            required="true">
        </flow-input>

        <flow-input
            id="password-input"
            class="order-2 transition-all duration-300"
            label="Contraseña"
            type="password"
            name="password"
            placeholder="••••••••"
            required="true">
        </flow-input>

        <!-- Botón físicamente aquí para el TAB, pero visualmente al final con order-4 -->
        <flow-button id="submit-btn" type="submit" variant="primary" class="order-4 mt-2 transition-all">
            Iniciar Sesión
        </flow-button>

        <div class="flex items-center justify-between pt-3 pb-2 order-3">
            <div id="remember-me-container" class="transition-all duration-300">
                <flow-checkbox name="remember-me" id="remember-me">
                    Recordarme
                </flow-checkbox>
            </div>

            <div class="text-sm">
                <a href="#" id="toggle-mode-link" class="font-medium text-blue-600 hover:text-blue-500 transition-colors">
                    ¿Olvidaste tu contraseña?
                </a>
            </div>
        </div>
    </form>
`;

export class LoginForm extends FlowComponent {
    static get styles() { return styles; }
    static get template() { return template; }

    #mode = 'login'; // 'login' | 'forgot-password'

    set loading(val) {
        const btn = this.root.querySelector('flow-button[type="submit"]');
        if (btn) btn.loading = val;

        const inputs = this.root.querySelectorAll('flow-input');
        inputs.forEach(input => {
            // Solo deshabilitamos si está visible (en modo forgot-password el password está oculto)
            if (val) {
                input.setAttribute('disabled', '');
            } else {
                input.removeAttribute('disabled');
            }
        });
    }

    onMount() {
        super.onMount();
        const form = this.root.querySelector('form');

        // Manejo nativo del submit
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.#processSubmit(form);
        });

        // Soporte para click en flow-button (si el botón es shadow dom y no propaga submit)
        const submitBtn = this.root.querySelector('flow-button[type="submit"]');
        if (submitBtn) {
            submitBtn.addEventListener('click', () => {
                if (form.reportValidity()) {
                    form.requestSubmit();
                }
            });
        }

        // Manejo del toggle de vista
        const toggleLink = this.root.getElementById('toggle-mode-link');
        toggleLink?.addEventListener('click', (e) => {
            e.preventDefault();
            this.#toggleMode();
        });
    }

    #toggleMode() {
        this.#mode = this.#mode === 'login' ? 'forgot-password' : 'login';
        
        const form = this.root.querySelector('form');
        const passwordInput = this.root.getElementById('password-input');
        const rememberMeContainer = this.root.getElementById('remember-me-container');
        const submitBtn = this.root.getElementById('submit-btn');
        const toggleLink = this.root.getElementById('toggle-mode-link');

        if (this.#mode === 'forgot-password') {
            form.setAttribute('action', '/api/v1/registration/resend-verification');
            
            passwordInput.style.display = 'none';
            passwordInput.removeAttribute('required');
            passwordInput.value = ''; // Limpiamos la contraseña por seguridad
            
            rememberMeContainer.style.display = 'none';
            
            submitBtn.innerHTML = 'Recuperar Password';
            toggleLink.textContent = 'Iniciar Sesión';
            
        } else {
            form.setAttribute('action', '/api/v1/auth/login');
            
            passwordInput.style.display = 'block';
            passwordInput.setAttribute('required', 'true');
            
            rememberMeContainer.style.display = 'block';
            
            submitBtn.innerHTML = 'Iniciar Sesión';
            toggleLink.textContent = '¿Olvidaste tu contraseña?';
        }
    }

    #processSubmit(form) {
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());

        if (this.#mode === 'login') {
            // Asegurar que data.rememberMe tenga un valor booleano correcto
            const rememberMeRaw = data['remember-me'];
            data.rememberMe = rememberMeRaw !== undefined && rememberMeRaw === 'on';
            
            // Eliminar el campo original para evitar confusión
            if ('remember-me' in data) {
                delete data['remember-me'];
            }
            
            this.emit('form:submit', {
                data,
                action: form.getAttribute('action'),
                method: form.getAttribute('method')
            });
        } else {
            // Modo recuperar password (Solo enviamos el email)
            const payload = { email: data.email };
            this.emit('form:resend', {
                data: payload,
                action: form.getAttribute('action'),
                method: form.getAttribute('method')
            });
        }
    }
}

customElements.define('login-form', LoginForm);
